// extracted by mini-css-extract-plugin
export var sbShowMain = "richText-module--sb-show-main--3L83-";
export var textStyle = "richText-module--textStyle--a1NQj";
export var narrowRichtext = "richText-module--narrowRichtext--3fTQO";
export var section = "richText-module--section--QoukK";